import { render, staticRenderFns } from "./leading.vue?vue&type=template&id=3510f9c4&scoped=true&"
import script from "./leading.vue?vue&type=script&lang=js&"
export * from "./leading.vue?vue&type=script&lang=js&"
import style0 from "./leading.vue?vue&type=style&index=0&id=3510f9c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510f9c4",
  null
  
)

export default component.exports